import { useEffect, useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "@/data/content";

export default function Reviews() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((v) => (v + 1) % REVIEWS.length), 6500);
    return () => clearInterval(id);
  }, []);

  const r = REVIEWS[i];

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative bg-[#F5F5F7] py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div className="eyebrow">Client Reviews</div>
        <div className="font-serif-display text-[120px] md:text-[180px] leading-none text-[#C8A44D] -mb-10 md:-mb-16 select-none">
          &ldquo;
        </div>

        <div className="relative min-h-[280px] md:min-h-[260px]">
          {REVIEWS.map((rev, idx) => (
            <div
              key={idx}
              data-testid={`review-${idx}`}
              className={`absolute inset-0 transition-opacity duration-700 ${
                idx === i ? "opacity-100" : "opacity-0 pointer-events-none"
              }`}
            >
              <p className="font-serif-display text-[#111] text-2xl md:text-4xl leading-snug tracking-tight max-w-3xl mx-auto">
                {rev.text}
              </p>
              <div className="mt-8 flex items-center justify-center gap-1 text-[#C8A44D]">
                {Array.from({ length: rev.rating }).map((_, k) => (
                  <Star key={k} size={16} fill="#C8A44D" strokeWidth={0} />
                ))}
              </div>
              <div className="mt-4 text-sm tracking-[0.24em] uppercase text-[#666]">
                {rev.name} · {rev.location}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-center justify-center gap-6">
          <button
            data-testid="review-prev"
            onClick={() => setI((v) => (v - 1 + REVIEWS.length) % REVIEWS.length)}
            className="w-10 h-10 rounded-full border border-[#111]/15 flex items-center justify-center hover:bg-[#111] hover:text-white transition-colors"
            aria-label="Previous review"
          >
            <ChevronLeft size={18} strokeWidth={1.5} />
          </button>
          <div className="flex gap-2">
            {REVIEWS.map((_, idx) => (
              <button
                key={idx}
                data-testid={`review-dot-${idx}`}
                onClick={() => setI(idx)}
                className={`h-[3px] transition-all ${
                  idx === i ? "w-8 bg-[#C8A44D]" : "w-4 bg-[#111]/20"
                }`}
                aria-label={`Show review ${idx + 1}`}
              />
            ))}
          </div>
          <button
            data-testid="review-next"
            onClick={() => setI((v) => (v + 1) % REVIEWS.length)}
            className="w-10 h-10 rounded-full border border-[#111]/15 flex items-center justify-center hover:bg-[#111] hover:text-white transition-colors"
            aria-label="Next review"
          >
            <ChevronRight size={18} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </section>
  );
}
